import { Button, Modal, notification, Table, InputNumber, Input } from 'antd';
import { Loading } from 'shared/components/Loading';
import React, { useEffect, useMemo, useState } from 'react';
import { apiWms } from 'shared/api';
import { creditNoteCode } from './utils';

const CreditNoteApprovalModal = React.memo(
	({
		showApproveCnModal,
		creditNoteData,
		setShowApproveCnModal,
		isWms,
		setReloadList
	}: {
		showApproveCnModal: any;
		creditNoteData: any;
		setShowApproveCnModal: any;
		isWms: boolean;
		setReloadList: any;
	}) => {
		const [loading, setLoading] = useState(false);
		const [originalItems] = useState(JSON.parse(JSON.stringify(creditNoteData?.creditNoteItems || [])));
		const [creditNoteItems, setCreditNoteItems] = useState(JSON.parse(JSON.stringify(creditNoteData?.creditNoteItems || [])));

		const onClose = () => {
			setShowApproveCnModal(false);
		};

		const handleItemChange = (index: number, key: string, value: any) => {
			const updatedItems = [...creditNoteItems];
			updatedItems[index][key] = value;
			setCreditNoteItems(updatedItems);
		};

		const totalCreditValue = useMemo(() => {
			return creditNoteItems.reduce((sum: any, item: any) => sum + item.finalPrice * item.quantity, 0);
		}, [creditNoteItems]);

		const getAvailableQuantity = (item: any) => {
			const x = creditNoteData.splitOrder.items.filter((i: any) => i.sku === item.sku);
			const totalDcnQuantity = x.reduce((sum: number, i: any) => sum + i.quantity, 0);
			return totalDcnQuantity;
		};

		const handleApproveCreditNote = async () => {
			try {
				setLoading(true);

				const isUpdatedQuantityIsMoreThanAvailable = creditNoteItems.some((item: any) => {
					const availableQuantity = getAvailableQuantity(item);
					return item.quantity > availableQuantity;
				});

				if (isUpdatedQuantityIsMoreThanAvailable) {
					notification.error({
						message: 'Error',
						description: 'One or more items have quantity more than available quantity.'
					});
					return;
				}

				const updatedItems = creditNoteItems
					.filter((item: any, index: number) => {
						return item.quantity !== originalItems[index]?.quantity;
					})
					.map((item: any) => ({
						sku: item.sku,
						quantity: item.quantity
					}));

				console.log(updatedItems);

				const data = await apiWms.put('/inventory/credit-note/approve', {
					creditNoteId: creditNoteData.id,
					items: updatedItems,
					CnStatus: isWms ? creditNoteCode.PICKED_UP : creditNoteCode.APPROVED
				});

				if (data.status) {
					notification.success({
						message: 'Success',
						description: 'Credit Note approved successfully'
					});
					setShowApproveCnModal(false);
					setReloadList((prev: number) => prev + 1);
				}
			} catch (err) {
				console.log(err);
				notification.error({
					message: 'Error',
					description: 'Failed to approve Credit Note'
				});
			} finally {
				setLoading(false);
			}
		};

		const columns: any = [
			{
				title: 'Title',
				dataIndex: 'title',
				key: 'title'
			},
			{
				title: 'SKU',
				dataIndex: 'sku',
				key: 'sku'
			},
			{
				title: 'HSN Code',
				dataIndex: 'hsnCode',
				key: 'hsnCode'
			},
			{
				title: 'Quantity',
				key: 'quantity',
				render: (data: any, record: any, index: number) =>
					isWms ? (
						<Input
							style={{ width: '35%' }}
							type="number"
							min={1}
							suffix={`/ ${getAvailableQuantity(data)}`}
							value={data.quantity}
							onChange={(e) => handleItemChange(index, 'quantity', Number(e.target.value))}
						/>
					) : (
						data.quantity
					)
			},
			{
				title: 'Final Price (₹)',
				dataIndex: 'finalPrice',
				key: 'finalPrice',
				render: (value: number) => `₹${Number(value).toFixed(2)}`
			}
		];

		return (
			<Modal
				bodyStyle={{ maxHeight: 500, overflowY: 'auto', padding: 0 }}
				width={900}
				open={showApproveCnModal}
				onCancel={onClose}
				title="Approve Credit Note"
				footer={null}
			>
				{loading && <Loading loading={loading} />}

				<div style={{ padding: 20 }}>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center'
						}}
					>
						<p>
							<strong>Credit Note ID:</strong>{' '}
							<Button
								type="link"
								onClick={() =>
									window.open(
										`https://wherehouse-prod-content.s3.ap-south-1.amazonaws.com/${creditNoteData?.creditNoteUrl}`,
										'_blank'
									)
								}
							>
								{creditNoteData?.creditNumber}
							</Button>
						</p>

						<p>
							<strong>Original Credit Note Value:</strong>{' '}
							{creditNoteData?.creditNoteFinalValue ? `₹${Number(creditNoteData?.creditNoteFinalValue).toFixed(2)}` : '-'}
						</p>
					</div>

					<h4 style={{ marginTop: 20 }}>Products in Credit Note</h4>
					<Table dataSource={creditNoteItems} columns={columns} rowKey="id" pagination={false} style={{ marginTop: 10 }} />

					<div
						style={{
							marginTop: 20,
							textAlign: 'right',
							fontSize: 16,
							fontWeight: 600
						}}
					>
						Total Credit Note Value: ₹{totalCreditValue.toFixed(2)}
					</div>

					<div
						style={{
							marginTop: 30,
							display: 'flex',
							justifyContent: 'flex-end',
							gap: 10
						}}
					>
						<Button type="primary" onClick={handleApproveCreditNote} disabled={loading}>
							Approve
						</Button>
					</div>
				</div>
			</Modal>
		);
	}
);
export default CreditNoteApprovalModal;
